import i18n from '../i18n';
import { store } from './store';
import UtilDate from '../utils/UtilDate';
import UtilObject from '../utils/UtilObject';
import UtilSocket from '../utils/UtilSocket';
import ApiLocalStorage from './ApiLocalStorage';
import UserActions from '../actions/UserActions';

const ApiStorage = {
  setLanguage: (lang) => {
    store.dispatch({ type: 'SET_LANG', payload: lang });
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  },
  setCurrentUserLanguage: (lang) => {
    const currentUser = ApiStorage.getCurrentUser();
    if (!currentUser?.idUser && !currentUser?.idClient) return;
    store.dispatch({
      type: 'SET_CURRENT_USER',
      payload: { ...currentUser, language: lang, lang },
    });
  },
  setSelectedTheme: (theme) => {
    store.dispatch({ type: 'SET_SELECTED_THEME', payload: theme });
  },
  setStepDetailsDone: (obj) => {
    const currentUser = ApiStorage.getCurrentUser();
    if (!currentUser?.stepsDone) {
      ApiStorage.setCurrentUser(
        Object.assign({}, currentUser, {
          stepsDoneDetails: { ...currentUser?.stepsDoneDetails, ...obj },
        })
      );
    }
  },
  setCurrentUser: (user) => {
    store.dispatch({ type: 'SET_CURRENT_USER', payload: user });
    ApiStorage.setSelectedTheme(
      ['light', 'dark', 'system'].includes(user?.selectedTheme)
        ? user.selectedTheme
        : 'light'
    );
    if (user?.hasOwnProperty('sessionToken')) {
      ApiStorage.setAccessToken(user.sessionToken);
      // ApiStorage.setTrialClose(false);
    }
    if (user?.hasOwnProperty('lang')) {
      ApiStorage.setLanguage(user.lang);
    }
    ApiStorage.setBadgeCountOrder(0);
    if (user?.hasOwnProperty('badgeCountOrder')) {
      ApiStorage.setBadgeCountOrder(user.badgeCountOrder);
    }
    ApiStorage.setBadgeCountPayment(0);
    if (user?.hasOwnProperty('badgeCountPayment')) {
      ApiStorage.setBadgeCountPayment(user.badgeCountPayment);
    }
    ApiStorage.setVisitPageFilters(UtilObject.EMPTY_OBJECT);
    ApiStorage.setCustomerPageFilters(UtilObject.EMPTY_OBJECT);
    ApiStorage.setCustomerStatementFilters(UtilObject.EMPTY_OBJECT);
    ApiStorage.setDebitPageFilters(UtilObject.EMPTY_OBJECT);
    ApiStorage.setAnalyticsFilters({
      date: 'THIS_MONTH',
      dateFrom: UtilDate.getThisMonthStart(),
      dateTo: UtilDate.getThisMonthEnd(),
    });
    ApiStorage.setManagerAnalyticsFilters({
      date: 'THIS_MONTH',
      dateFrom: UtilDate.getThisMonthStart(),
      dateTo: UtilDate.getThisMonthEnd(),
      idCustomer: [],
    });
    ApiStorage.setUserPageFilters(UtilObject.EMPTY_OBJECT);
    ApiStorage.setDevicePageFilters(UtilObject.EMPTY_OBJECT);
    ApiStorage.setPolicyPageFilters(UtilObject.EMPTY_OBJECT);
    ApiStorage.setBranchPageFilters(UtilObject.EMPTY_OBJECT);
    ApiStorage.setProductQuantitiesFilters(UtilObject.EMPTY_OBJECT);
    ApiStorage.setProductListState(UtilObject.EMPTY_OBJECT);
    // if (user?.idClient) {
    //   UtilSocket.startClientChannel(user.idClient)
    // }
  },
  setAccessToken: (accessToken) => {
    store.dispatch({ type: 'SET_ACCESS_TOKEN', payload: accessToken });
  },
  getAccessToken: () => {
    const { accessToken } = store.getState();
    return accessToken;
  },
  setBadgeCountOrder: (badgeCount) => {
    store.dispatch({ type: 'SET_BADGE_COUNT_ORDER', payload: badgeCount });
  },
  getBadgeCountOrder: () => {
    const { badgeCountOrder } = store.getState();
    return badgeCountOrder;
  },
  setBadgeCountPayment: (badgeCount) => {
    store.dispatch({ type: 'SET_BADGE_COUNT_PAYMENT', payload: badgeCount });
  },
  setBadgeCountCustomer: (badgeCount) => {
    store.dispatch({ type: 'SET_BADGE_COUNT_CUSTOMER', payload: badgeCount });
  },
  getSelectedTheme: () => {
    const { selectedTheme } = store.getState();
    return selectedTheme;
  },
  getOrderPageFilters: () => {
    const { orderPageFilters } = store.getState();
    return orderPageFilters;
  },
  setOrderPageFilters: (orderPageFilters) => {
    store.dispatch({
      type: 'SET_ORDER_PAGE_FILTERS',
      payload: orderPageFilters,
    });
  },
  getPaymentPageFilters: () => {
    const { paymentPageFilters } = store.getState();
    return paymentPageFilters;
  },
  setPaymentPageFilters: (paymentPageFilters) => {
    store.dispatch({
      type: 'SET_PAYMENT_PAGE_FILTERS',
      payload: paymentPageFilters,
    });
  },
  getVisitPageFilters: () => {
    const { visitPageFilters } = store.getState();
    return visitPageFilters;
  },
  setVisitPageFilters: (visitPageFilters) => {
    store.dispatch({
      type: 'SET_VISIT_PAGE_FILTERS',
      payload: visitPageFilters,
    });
  },
  getUserPageFilters: () => {
    const { userPageFilters } = store.getState();
    return userPageFilters;
  },
  setUserPageFilters: (userPageFilters) => {
    if (UtilObject.isEmpty(userPageFilters)) {
      userPageFilters = { status: UserActions.STATUS.ACTIVE };
    }
    store.dispatch({
      type: 'SET_USER_PAGE_FILTERS',
      payload: userPageFilters,
    });
  },
  getDevicePageFilters: () => {
    const { devicePageFilters } = store.getState();
    return devicePageFilters;
  },
  setDevicePageFilters: (devicePageFilters) => {
    store.dispatch({
      type: 'SET_DEVICE_PAGE_FILTERS',
      payload: devicePageFilters,
    });
  },
  getPolicyPageFilters: () => {
    const { policyPageFilters } = store.getState();
    return policyPageFilters;
  },
  setPolicyPageFilters: (policyPageFilters) => {
    store.dispatch({
      type: 'SET_POLICY_PAGE_FILTERS',
      payload: policyPageFilters,
    });
  },

  getBranchPageFilters: () => {
    const { branchPageFilters } = store.getState();
    return branchPageFilters;
  },
  setBranchPageFilters: (branchPageFilters) => {
    store.dispatch({
      type: 'SET_BRANCH_PAGE_FILTERS',
      payload: branchPageFilters,
    });
  },
  getDebitPageFilters: () => {
    const { debitPageFilters } = store.getState();
    return debitPageFilters;
  },
  setDebitPageFilters: (debitPageFilters) => {
    store.dispatch({
      type: 'SET_DEBIT_PAGE_FILTERS',
      payload: debitPageFilters,
    });
  },
  getProductPageFilters: () => {
    const { productPageFilters } = store.getState();
    return productPageFilters;
  },
  setProductPageFilters: (productPageFilters) => {
    store.dispatch({
      type: 'SET_PRODUCT_PAGE_FILTERS',
      payload: productPageFilters,
    });
  },
  getUserQuantitiesFilters: () => {
    const { userQuantitiesFilters } = store.getState();
    return userQuantitiesFilters;
  },
  setUserQuantitiesFilters: (userQuantitiesFilters) => {
    store.dispatch({
      type: 'SET_USER_QUANTITIES_FILTERS',
      payload: userQuantitiesFilters,
    });
  },
  getProductQuantitiesFilters: () => {
    const { productQuantitiesFilters } = store.getState();
    return productQuantitiesFilters;
  },
  setProductQuantitiesFilters: (productQuantitiesFilters) => {
    store.dispatch({
      type: 'SET_PRODUCT_QUANTITIES_FILTERS',
      payload: productQuantitiesFilters,
    });
  },
  getProductListState: () => {
    const { productListState } = store.getState();
    return productListState;
  },
  setProductListState: (productListState) => {
    store.dispatch({
      type: 'SET_PRODUCT_LIST_STATE',
      payload: productListState,
    });
  },
  // getInventoryQuantitiesFilters: () => {
  //   const { inventoryQuantityFilters } = store.getState();
  //   return inventoryQuantityFilters;
  // },
  // setInventoryQuantitiesFilters: (filter) => {
  //   store.dispatch({
  //     type: 'SET_INVENTORY_QUANTITY_FILTERS',
  //     payload: filter,
  //   });
  // },
  getCustomerStatementFilters: () => {
    const { customerStatementFilters } = store.getState();
    return customerStatementFilters;
  },
  setCustomerStatementFilters: (customerStatementFilters) => {
    store.dispatch({
      type: 'SET_CUSTOMER_STATEMENT_FILTERS',
      payload: customerStatementFilters,
    });
  },
  getAnalyticsFilters: () => {
    const { analyticsFilters } = store.getState();
    return analyticsFilters;
  },
  setAnalyticsFilters: (analyticsFilters) => {
    const serialized = { ...analyticsFilters };
    if (serialized.dateFrom && typeof serialized.dateFrom !== 'string') {
      serialized.dateFrom = serialized.dateFrom.toISOString();
    }
    if (serialized.dateTo && typeof serialized.dateTo !== 'string') {
      serialized.dateTo = serialized.dateTo.toISOString();
    }
    store.dispatch({
      type: 'SET_ANALYTICS_FILTERS',
      payload: serialized,
    });
  },
  getManagerAnalyticsFilters: () => {
    const { managerAnalyticsFilters } = store.getState();
    return managerAnalyticsFilters;
  },
  setManagerAnalyticsFilters: (managerAnalyticsFilters) => {
    const serialized = { ...managerAnalyticsFilters };
    if (serialized.dateFrom && typeof serialized.dateFrom !== 'string') {
      serialized.dateFrom = serialized.dateFrom.toISOString();
    }
    if (serialized.dateTo && typeof serialized.dateTo !== 'string') {
      serialized.dateTo = serialized.dateTo.toISOString();
    }
    store.dispatch({
      type: 'SET_MANAGER_ANALYTICS_FILTERS',
      payload: serialized,
    });
  },
  setCustomerPageFilters: (customerPageFilters) => {
    store.dispatch({
      type: 'SET_CUSTOMER_PAGE_FILTERS',
      payload: customerPageFilters,
    });
  },
  setDeviceKey: (deviceKey) => {
    store.dispatch({ type: 'SET_DEVICEKEY', payload: deviceKey });
  },
  getDeviceKey: () => {
    const { deviceKey } = store.getState();
    return deviceKey;
  },
  getCurrentUser: () => {
    const { currentUser } = store.getState();
    return currentUser;
  },
  getCanEdit: () => {
    const { canEdit } = store.getState();
    return canEdit;
  },
  clearUser: () => {
    UtilSocket.closeSocket();
    ApiStorage.setCurrentUser({});
    ApiStorage.setSelectedTheme('light');
    ApiStorage.setAccessToken('');
    ApiLocalStorage.removeItem(ApiLocalStorage.TEMP_REMEMBER_ME);
  },
};

export default ApiStorage;
